import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/event/TIOT",
        name: "TiotEventPage",
        redirect: () => {
            return { name: "EventAppDetailView", params: { id: 44 } };
        },
    },
];

export default routes;
